import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Layers, Activity, BookOpen, ChevronLeft } from 'lucide-react';
import clsx from 'clsx';
import { useLanguage } from '../contexts/LanguageContext';

export const SessionSubNav = ({ sessionId, isMultiTable = false }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useLanguage();

    const isActive = (path) => {
        // Handle cases like /session/ID/ledger/1 vs /session/ID/ledger (defaulting to 1)
        if (location.pathname === path) return true;
        if (path.endsWith('/ledger/1') && location.pathname === `/session/${sessionId}/ledger`) return true;
        return false;
    };

    const navItems = [
        { 
            path: `/session/${sessionId}`, 
            label: 'Home', 
            icon: <Home className="w-4 h-4" />,
            active: location.pathname === `/session/${sessionId}`
        },
        { 
            path: `/session/${sessionId}/ledger/1`, 
            label: isMultiTable ? 'Table 1' : 'Ledger', 
            icon: <Activity className="w-4 h-4" />,
            active: isActive(`/session/${sessionId}/ledger/1`)
        }
    ];

    if (isMultiTable) {
        navItems.push({ 
            path: `/session/${sessionId}/ledger/2`, 
            label: 'Table 2', 
            icon: <Activity className="w-4 h-4" />,
            active: isActive(`/session/${sessionId}/ledger/2`)
        });
        navItems.push({ 
            path: `/session/${sessionId}/ledger/master`, 
            label: 'Master', 
            icon: <Layers className="w-4 h-4" />,
            active: isActive(`/session/${sessionId}/ledger/master`)
        });
    }

    return (
        <div className="w-full bg-slate-900/80 backdrop-blur-xl border-b border-white/5 sticky top-[64px] z-[40] animate-in slide-in-from-top duration-300">
            <div className="max-w-xl mx-auto px-4 overflow-x-auto no-scrollbar">
                <div className="flex items-center gap-1 py-2">
                    {navItems.map((item) => (
                        <button
                            key={item.path}
                            onClick={() => navigate(item.path)}
                            className={clsx(
                                "flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-black transition-all whitespace-nowrap uppercase tracking-wider",
                                item.active 
                                    ? "bg-amber-500 text-slate-950 shadow-lg shadow-amber-500/20 scale-105" 
                                    : "text-slate-500 hover:text-slate-300 hover:bg-white/5"
                            )}
                        >
                            {item.icon}
                            <span>{item.label}</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};
